import type { OnInit } from '@angular/core';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorHandlerService } from '../shared/services/error-handler.service';

@Component({
  standalone: false,
  selector: 'invd-global-error',
  templateUrl: './global-error.component.html',
  styleUrls: ['./global-error.component.scss'],
})
export class GlobalErrorComponent implements OnInit {
  public displayMessage = '';
  public displayStatusCode: number;
  public displayResolution = '';
  public displayErrorCode = '';

  public errorObj: any;

  private errorHandlerService = inject(ErrorHandlerService);
  private router = inject(Router);

  ngOnInit() {
    this.errorObj = this.errorHandlerService.getErrorObj();
    // this.displayMessage= this.errorObj.displayMessage ;
    // this.displayStatusCode= this.errorObj.statusCode ;
    this.displayResolution = this.errorObj.messages[0].errorMessage;
    this.displayErrorCode = this.errorObj.messages[0].messageCode;
  }

  public goToHome(): void {
    this.router.navigate(['']);
  }
}
